import httpService from "../_utils/http-service";
import { getAuthHttpConfig } from "../_utils/auth-utils";
import * as types from "./types";
import { traceEvent } from "../_utils/analytics-utils";

export const setFriends = friends => {
  return { type: types.SET_FRIENDS, payload: friends };
};

export const fetchFriends = (customerId, callback) => {
  return function(dispatch, getState) {
    const storage = getState().storage;
    httpService
      .get(`/v2/customers/${customerId}/friends`, getAuthHttpConfig(storage))
      .then(res => {
        if (res.data.statusCode === 200) {
          const { friends, pendingRequests } = res.data.data;
          callback({
            success: true,
            friends,
            pendingRequests
          });
        } else {
          callback({
            success: false
          });
          traceEvent("error", "fetchFriends");
        }
      })
      .catch(err => {
        callback({ success: false });
        traceEvent("error", "fetchFriends");
      });
  };
};

export const fetchPendingRequests = (customerId, callback) => {
  return function(dispatch, getState) {
    const storage = getState().storage;
    httpService
      .get(
        `/v2/customers/${customerId}/friends/requests`,
        getAuthHttpConfig(storage)
      )
      .then(res => {
        if (res.data.statusCode === 200) {
          callback({
            success: true,
            requests: res.data.data
          });
        } else {
          callback({
            success: false
          });
        }
      })
      .catch(err => {
        callback({ success: false });
      });
  };
};

export const tagFriend = ({ customerId, id, tags }, callback) => {
  return function(dispatch, getState) {
    const storage = getState().storage;
    httpService
      .post(
        `/v2/customers/${customerId}/friends/tag`,
        { id, tags },
        getAuthHttpConfig(storage)
      )
      .then(res => {
        if (res.data.statusCode === 200) {
          callback({
            success: true,
            friend: res.data.data
          });
        } else {
          callback({
            success: false
          });
        }
      })
      .catch(err => {
        callback({ success: false });
      });
  };
};

export const unfriend = ({ customerId, friendId }, callback) => {
  return function(dispatch, getState) {
    const storage = getState().storage;
    httpService
      .post(
        `/v2/customers/${customerId}/friends/unfriend`,
        { friendId },
        getAuthHttpConfig(storage)
      )
      .then(res => {
        if (res.data.statusCode === 200) {
          callback({
            success: true
          });
        } else {
          callback({
            success: false
          });
        }
      })
      .catch(err => {
        callback({ success: false });
      });
  };
};

const replyOnFriendRequest = (url, requestId, callback) => {
  return function(dispatch, getState) {
    const storage = getState().storage;
    httpService
      .post(url, { requestId }, getAuthHttpConfig(storage))
      .then(res => {
        if (res.data.statusCode === 200) {
          callback({
            success: true
          });
        } else {
          callback({
            success: false
          });
        }
      })
      .catch(err => {
        callback({ success: false });
      });
  };
};

export const acceptFriendRequest = ({ customerId, requestId }, callback) => {
  return replyOnFriendRequest(
    `/v2/customers/${customerId}/friends/accept`,
    requestId,
    callback
  );
};

export const rejectFriendRequest = ({ customerId, requestId }, callback) => {
  return replyOnFriendRequest(
    `/v2/customers/${customerId}/friends/reject`,
    requestId,
    callback
  );
};

export const cancelFriendRequest = ({ customerId, requestId }, callback) => {
  return function(dispatch, getState) {
    const storage = getState().storage;
    httpService
      .post(
        `/v2/customers/${customerId}/friends/cancel`,
        { requestId },
        getAuthHttpConfig(storage)
      )
      .then(res => {
        if (res.data.statusCode === 200) {
          callback({
            success: true
          });
        } else {
          callback({
            success: false
          });
        }
      })
      .catch(err => {
        callback({ success: false });
      });
  };
};

export const fetchFriendsInvited = (customerId, callback) => {
  return function(dispatch, getState) {
    const storage = getState().storage;
    httpService
      .get(
        `/v2/customers/${customerId}/friends/invites`,
        getAuthHttpConfig(storage)
      )
      .then(res => {
        if (res.data.statusCode === 200) {
          callback({
            success: true,
            inviteList: res.data.data
          });
        } else {
          callback({
            success: false
          });
        }
      })
      .catch(err => {
        callback({ success: false });
      });
  };
};

export const findFriend = (phoneOrEmail, callback) => {
  return function(dispatch, getState) {
    const storage = getState().storage;
    httpService
      .post(
        `/v2/customers/friends/find`,
        {
          phoneOrEmail
        },
        getAuthHttpConfig(storage)
      )
      .then(res => {
        if (res.data.statusCode === 200) {
          callback({
            success: true,
            friend: res.data.data
          });
        } else {
          callback({
            success: false
          });
        }
      })
      .catch(err => {
        callback({ success: false });
      });
  };
};

export const sendFriendRequest = ({ customerId, friendId }, callback) => {
  return function(dispatch, getState) {
    const storage = getState().storage;
    httpService
      .post(
        `/v2/customers/${customerId}/friends/send`,
        { friendId },
        getAuthHttpConfig(storage)
      )
      .then(res => {
 
        if (res.data.statusCode === 200) {
          callback({
            success: true
          });
        } else if (res.data.statusCode === 500) {
          callback({
            success: false,
            statusCode: 500
          });
        } else {
          callback({
            success: false
          });
        }
      })
      .catch(err => {
        callback({ success: false });
      });
  };
};

export const fetchOrderInvites = ({ customerId, orderId }, callback) => {
  return function(dispatch, getState) {
    const storage = getState().storage;
    httpService
      .get(
        `/v2/customers/${customerId}/orders/${orderId}/invites`,
        getAuthHttpConfig(storage)
      )
      .then(res => {
        if (res.data.statusCode === 200) {
          callback({
            success: true,
            invites: res.data.data
          });
        } else {
          callback({
            success: false
          });
        }
      })
      .catch(err => {
        callback({ success: false });
      });
  };
};

export const sendOrderInvites = (
  { customerId, orderId, friendIds },
  callback
) => {
  return function(dispatch, getState) {
    const storage = getState().storage;

    httpService
      .post(
        `/v2/customers/${customerId}/orders/${orderId}/invites/send`,
        { friendIds },
        getAuthHttpConfig(storage)
      )
      .then(res => {
        if (res.data.statusCode === 200) {
          callback({
            success: true,
            invited: res.data.data
          });
        } else {
          callback({
            success: false
          });
        }
      })
      .catch(err => {
        callback({ success: false });
      });
  };
};

export const setFriendDisplayName = ({ id, displayName }, callback) => {
  return function(dispatch, getState) {
    const storage = getState().storage;
    httpService
      .post(
        `/v2/customers/friends/name`,
        { id, displayName },
        getAuthHttpConfig(storage)
      )
      .then(res => {
        if (res.data.statusCode === 200) {
          callback({
            success: true,
            friend: res.data.data
          });
        } else {
          callback({
            success: false
          });
        }
      })
      .catch(err => {
        callback({ success: false });
      });
  };
};
